import React from 'react'

export default function LandingTable(props) {
    return (
        <p>
            Here a chart
        </p>
    )
}